import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { filterProductsConfigByTab, isValidTab } from '../../utils/tabFiltering';
import { useIsUngatedForV2PublicHubPages } from '../gating/useIsUngated';
import { useIsInAppAuth } from '../user/useUserInfo';
export const useTabAwareProductsConfig = fullConfig => {
  const {
    tab
  } = useParams();
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const isInAppAuth = useIsInAppAuth();
  const showPublicTabsOnV2 = useIsUngatedForV2PublicHubPages();
  const isPublic = !isInAppAuth;
  const shouldRedirect = isPublic && showPublicTabsOnV2 && !tab;
  const redirectPath = shouldRedirect ? `${pathname}/enterprise` : null;

  // Redirect to enterprise tab if on public page with no tab.
  // No infinite loop risk: after redirect, `tab` becomes defined, so shouldRedirect becomes false.
  useEffect(() => {
    if (redirectPath) {
      history.replace(redirectPath);
    }
  }, [redirectPath, history]);
  if (!isPublic || !showPublicTabsOnV2) {
    return fullConfig;
  }

  // Default to enterprise tab if no valid tab is provided
  const activeTab = isValidTab(tab) ? tab : 'enterprise';
  return filterProductsConfigByTab(fullConfig, activeTab);
};